import { Component, OnInit } from '@angular/core';
import { SettingsService } from './shared/services/settings.service';
import * as _ from 'lodash';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(private appSettings: SettingsService, private router: Router) {}

  private settings: any;

  ngOnInit() {
    this.appSettings.set(this.appSettings.configSettings);
    this.settings = this.appSettings.configSettings;
    //this.checkAccess();
    this.setBrowserCSSClasses(navigator.userAgent);
    if (!$('html').hasClass('mobile')) {
      $('html').addClass('desktop');
    }
  }

  checkAccess(): void {
    console.log('checkAccessStatus', 'checkAccessStatus');
    console.debug('DEBUG ON');
    console.info('INFO ON');
    console.log('LOG ON');
  }

  // Open the login modal
  login(): void {}

  setBrowserCSSClasses(u) {
    const ua = u.toLowerCase(),
      is = function (t) {
        return ua.indexOf(t) > -1;
      };
    let g = 'gecko';
    const w = 'webkit',
      s = 'safari',
      o = 'opera',
      m = 'mobile',
      i = 'ios';
    g = g + ' firefox';
    const h = document.documentElement;
    const b = [
      !/opera|webtv/i.test(ua) && /msie\s(\d)/.test(ua)
        ? 'ie ie' + RegExp.$1
        : is('firefox/2')
        ? g + ' ff2'
        : is('firefox/3.5')
        ? g + ' ff3 ff3_5'
        : is('firefox/3.6')
        ? g + ' ff3 ff3_6'
        : is('firefox/3')
        ? g + ' ff3'
        : is('firefox/5')
        ? g + ' ff5'
        : is('firefox/6')
        ? g + ' ff6'
        : is('firefox/7')
        ? g + ' ff7'
        : is('firefox/8')
        ? g + ' ff8'
        : is('firefox/9')
        ? g + ' ff9'
        : is('firefox/10')
        ? g + ' ff10'
        : is('gecko/')
        ? g
        : is('opera')
        ? o +
          (/version\/(\d+)/.test(ua)
            ? ' ' + o + RegExp.$1
            : /opera(\s|\/)(\d+)/.test(ua)
            ? ' ' + o + RegExp.$2
            : '')
        : is('konqueror')
        ? 'konqueror'
        : is('blackberry')
        ? m + ' blackberry'
        : is('android')
        ? m + ' android'
        : is('chrome')
        ? w + ' chrome'
        : is('iron')
        ? w + ' iron'
        : is('applewebkit/')
        ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '')
        : is('mozilla/')
        ? g
        : '',
      is('j2me')
        ? m + ' j2me'
        : is('iphone')
        ? m + ' iphone'
        : is('ipod')
        ? m + ' ipod'
        : is('ipad')
        ? m + ' ipad'
        : is('mac')
        ? 'mac'
        : is('darwin')
        ? 'mac'
        : is('webtv')
        ? 'webtv'
        : is('win')
        ? 'win' +
          (is('windows nt 5.1')
            ? ' xp'
            : is('windows nt 6.0')
            ? ' vista'
            : is('windows nt 6.1')
            ? ' win7'
            : '')
        : is('freebsd')
        ? 'freebsd'
        : is('x11') || is('linux')
        ? 'linux'
        : '',
      /cpu\sos\s5/.test(ua) ? i + '5' : /cpu\sos\s4/.test(ua) ? i + '4' : '',
      'js',
    ];
    const c = b.join(' ');
    h.className += ' ' + c;
    return c;
  }
}
